import React, { useEffect, useRef } from "react";

const VehicleBrandActionDropdown = ({
  isOpen,
  headers,
  row,
  onActionClick,
  onClose,
}) => {
  const dropdownRef = useRef(null);

  // Effect to handle clicks outside the dropdown
  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Handle action with closing
  const handleAction = (action) => {
    onActionClick(action, row, headers);
    onClose();
  };

  return (
    <div
      ref={dropdownRef}
      className="absolute right-0 mt-2 w-40 bg-white border rounded shadow-md z-10"
      onClick={(e) => e.stopPropagation()}
    >
      <ul className="list-none">
        <li
          className="px-4 py-2 hover:bg-red-50 cursor-pointer text-red-600"
          onClick={() => handleAction("Delete")}
        >
          Delete
        </li>
      </ul>
    </div>
  );
};

export default VehicleBrandActionDropdown;
